import * as types from '../types';

const initialState = {
  policyHoldersList: [],
  isFetchingPolicyHolders: false,
  errors: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_POLICY_HOLDERS_DATA:
      return {
        ...state,
        isFetchingPolicyHolders: true,
        errors: []
      };

    case types.FETCH_POLICY_HOLDERS_SUCCEEDED:
      return {
        ...state,
        policyHoldersList: action.payload,
        isFetchingPolicyHolders: false,
        errors: []
      };

    case types.RESET_POLICY_HOLDERS:
    case types.FETCH_POLICY_HOLDERS_FAILED:
      return {
        ...state,
        policyHoldersList: [],
        errors: action.payload,
        isFetchingPolicyHolders: false
      };

    default:
      return state;
  }
};
